import req from '../api.js'
/* 校企合作列表 */
export const HTTP_factorsIndex = (page, size) => req('/api/factors/index', { page, size })
/* 校企合作详情 */
export const HTTP_factorsDetail = (id) => req('/api/factors/detail', { id })